import { Component, OnInit } from '@angular/core';
import {KontableComponent} from "../../../modules/UIKit/components/kontable/kontable.component";
import {PromotionCatalogTypeGiftService} from "../../../services/promotion/promotion-catalog-type-gift.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-catalog-gift-type',
  templateUrl: './catalog-gift-type.component.html',
  styleUrls: ['./catalog-gift-type.component.css']
})
export class CatalogGiftTypeComponent implements OnInit {

  paginationType = KontableComponent.ServerPagination;
  customFilter = KontableComponent.CustomFilter;
  numberFilter = KontableComponent.NumberFilter;
  selectFilter = KontableComponent.SelectFilter;

  constructor(
    public catalogTypeGiftService: PromotionCatalogTypeGiftService,
    private router: Router
  ) {
  }

  ngOnInit() {
  }

  editCatalog(id: number){
    this.router.navigate([`promotion/catalog-gift-type/detail/${id}`]);
  }

  addCatalog(){
    this.router.navigate(['promotion/catalog-gift-type/detail']);
  }

  deleteCatalog(id: number, table){
    this.catalogTypeGiftService.deleteCatalogTypeGift(id).subscribe(() => table.refresh());
  }
}



// WEBPACK FOOTER //
// ./src/app/views/promotion/catalog-gift-type/catalog-gift-type.component.ts